(function () {
  'use strict';

  if (window.MLAthleticMotion) window.MLAthleticMotion.destroy();

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var pending = new Set();
  var seen = new WeakSet();
  var observer;
  var settingsObserver;
  var scrollTimer;
  var started = false;
  var destroyed = false;
  var revealedCount = 0;
  var registeredCount = 0;

  function allowed() {
    return !reduced.matches && !(connection && connection.saveData) &&
      document.body.getAttribute('data-motion-enabled') !== 'false';
  }

  function find(scope, selector) {
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) nodes.unshift(scope);
    return nodes;
  }

  function reveal(node) {
    if (!pending.has(node)) return;
    pending.delete(node);
    if (observer) observer.unobserve(node);
    node.classList.add('is-visible');
    revealedCount += 1;
  }

  function revealAll() {
    Array.from(pending).forEach(reveal);
  }

  function initialize(scope) {
    find(scope, '[data-ath-reveal]').forEach(function (node) {
      if (seen.has(node)) return;
      seen.add(node);
      registeredCount += 1;
      if (!allowed() || !observer || node.contains(document.activeElement)) {
        node.classList.add('is-visible');
        return;
      }
      var order = Math.max(0, Math.min(4, Number(node.getAttribute('data-ath-order')) || 0));
      node.style.setProperty('--ath-delay', order * 70 + 'ms');
      node.classList.add('ath-ready');
      pending.add(node);
      observer.observe(node);
    });
    updateTop();
  }

  function preferencesChanged() {
    document.body.setAttribute('data-ath-motion', allowed() ? 'on' : 'off');
    if (!allowed()) revealAll();
  }

  function updateTop() {
    scrollTimer = null;
    document.querySelectorAll('[data-ath-top]').forEach(function (button) {
      // A focused control stays present until focus moves elsewhere.
      button.hidden = window.scrollY < 800 && document.activeElement !== button;
    });
  }

  function onScroll() {
    if (scrollTimer == null) scrollTimer = window.setTimeout(updateTop, 60);
  }

  function onFocus(event) {
    Array.from(pending).forEach(function (node) {
      if (node === event.target || node.contains(event.target)) {
        node.style.setProperty('transition', 'none');
        reveal(node);
      }
    });
  }

  function onBlur(event) {
    if (event.target.matches && event.target.matches('[data-ath-top]')) {
      if (scrollTimer != null) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateTop, 0);
    }
  }

  function onClick(event) {
    var button = event.target.closest && event.target.closest('[data-ath-top]');
    if (!button) return;
    event.preventDefault();
    var target = document.querySelector('[data-ath-top-target], #MainContent, main');
    if (target) {
      var temporaryTabindex = !target.hasAttribute('tabindex');
      if (temporaryTabindex) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (temporaryTabindex) target.addEventListener('blur', function cleanup() {
        target.removeAttribute('tabindex');
      }, { once: true });
    }
    window.scrollTo({ top: 0, behavior: allowed() ? 'smooth' : 'instant' });
  }

  function sectionLoaded(event) { initialize(event.target); }
  function sectionUnloaded(event) {
    Array.from(pending).forEach(function (node) {
      if (node === event.target || event.target.contains(node)) reveal(node);
    });
  }

  function start() {
    if (started || destroyed) return;
    started = true;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -5% 0px', threshold: 0.08 });
    }
    preferencesChanged();
    initialize(document);
    settingsObserver = new MutationObserver(preferencesChanged);
    settingsObserver.observe(document.body, { attributes: true, attributeFilter: ['data-motion-enabled'] });
    if (reduced.addEventListener) reduced.addEventListener('change', preferencesChanged);
    else reduced.addListener(preferencesChanged);
    if (connection && connection.addEventListener) connection.addEventListener('change', preferencesChanged);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('focusin', onFocus);
    document.addEventListener('focusout', onBlur);
    document.addEventListener('click', onClick);
    document.addEventListener('shopify:section:load', sectionLoaded);
    document.addEventListener('shopify:section:unload', sectionUnloaded);
  }

  window.MLAthleticMotion = {
    snapshot: function () {
      return { enabled: started && !destroyed && allowed(), pending: pending.size, registered: registeredCount, revealed: revealedCount };
    },
    destroy: function () {
      destroyed = true;
      document.removeEventListener('DOMContentLoaded', start);
      if (!started) return;
      document.body.setAttribute('data-ath-motion', 'off');
      revealAll();
      if (observer) observer.disconnect();
      if (settingsObserver) settingsObserver.disconnect();
      if (scrollTimer != null) window.clearTimeout(scrollTimer);
      if (reduced.removeEventListener) reduced.removeEventListener('change', preferencesChanged);
      else reduced.removeListener(preferencesChanged);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', preferencesChanged);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('focusin', onFocus);
      document.removeEventListener('focusout', onBlur);
      document.removeEventListener('click', onClick);
      document.removeEventListener('shopify:section:load', sectionLoaded);
      document.removeEventListener('shopify:section:unload', sectionUnloaded);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
